/* eslint-disable sort-keys-fix/sort-keys-fix */
/* eslint-disable sort-keys */
import { rgba } from 'polished';
import Theme from '../types/theme';
import { decrease, increase } from '../colors/chartPalette';
import * as colorPalette from '../colors/defaultPalette';

const colors = {
  accent: colorPalette.orange,
  accentDark: colorPalette.orangeDark,

  accentDarker: colorPalette.orangeDarker,
  accentForeground: colorPalette.black,
  accentLight: colorPalette.orangeLight,
  accentLighter: colorPalette.orangeLighter,
  accentMuted: '#b68435',

  actionDisabled: rgba(colorPalette.neutral500, 0.8),
  actionDisabledBackground: rgba(colorPalette.neutral500, 0.24),
  actionFocus: rgba(colorPalette.neutral500, 0.24),
  actionHover: rgba(colorPalette.neutral500, 0.08),
  actionSelected: rgba(colorPalette.neutral500, 0.16),

  background: colorPalette.greyDarkest,
  backgroundActive: colorPalette.black,
  backgroundInactive: colorPalette.greyDarker,

  banner: '#818B9729',

  blindMode: 'none',

  border: colorPalette.greyDarker,
  borderDark: colorPalette.grayDark,
  borderLight: colorPalette.grayDark,
  borderUnified: colorPalette.grayDark,

  brand: colorPalette.blue,
  brandDark: colorPalette.blueDark,
  brandDarker: colorPalette.blueDarker,
  brandForeground: colorPalette.white,

  brandLight: colorPalette.blueLight,
  brandLighter: colorPalette.blueLighter,
  brandMuted: '#0076cd',
  brandUnified: colorPalette.blue,

  buttonPrimary: colorPalette.white,
  buttonPrimaryBackground: '#0076cd',
  buttonPrimaryBackgroundHover: colorPalette.blue,
  buttonPrimaryBorder: '#0076cd',
  buttonPrimaryUnified: colorPalette.white,
  buttonPrimaryBackgroundUnified: '#0076cd',

  danger: colorPalette.red,
  dangerDark: colorPalette.redDark,
  dangerDarker: colorPalette.redDarker,
  dangerForeground: colorPalette.white,

  dangerLight: colorPalette.redLight,
  dangerLighter: colorPalette.redLighter,

  dropdownBackground: colorPalette.greyDarkest,
  dropdownBackgroundActive: colorPalette.black,

  foreground: colorPalette.greyLighter,
  foregroundActive: colorPalette.white,
  foregroundInactive: colorPalette.greyLight,
  foregroundMuted: colorPalette.neutral200,
  information: colorPalette.blue,

  statistic: {
    negative: colorPalette.red,
    neutral: colorPalette.white,
    positive: colorPalette.green,
  },

  success: colorPalette.green,
  successDark: colorPalette.greenDark,
  successDarker: colorPalette.greenDarker,
  successForeground: colorPalette.white,
  successLight: colorPalette.greenLight,
  successLighter: colorPalette.greenLighter,

  warning: colorPalette.yellow,
  warningDark: colorPalette.yellowDark,
  warningDarker: colorPalette.yellowDarker,
  warningForeground: colorPalette.white,
  warningLight: colorPalette.yellowLight,
  warningLighter: colorPalette.yellowLighter,
};

const chart = {
  color: {
    accentColor1: 'rgba(73, 83, 96, .3)',
    accentColor2: 'rgba(73, 83, 96, 1)',
    mainColor: 'rgba(255, 255, 255, 1)',
    periods: {
      decrease,
      increase,
    },
    tooltipBackground: 'rgba(40, 49, 60, 1)',
  },
};

const dark: Partial<Theme> = {
  chart,
  colors: colors,
  name: 'dark',
};

export default dark;
